import script from "./CoverElButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverElButton.vue?vue&type=script&setup=true&lang=ts"

import "./CoverElButton.vue?vue&type=style&index=0&id=4f364de0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f364de0"]])

export default __exports__